import React from "react";
import HelpIcon from "@mui/icons-material/Help";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationInputStyle, Color } from "../../constants";
import { Box, Stack, Tooltip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FettiSelect from "../FettiSelect";
import { updateAppData } from "../../utils/actionUtils";

// subcomponent of ResumeApply

// headerStyle/misc is used because this shows up in survey and in apply

const ResumeSelect = ({ headerStyle = null }) => {
  const dispatch = useDispatch();
  const apply = useSelector((state) => state.apply);
  const appData = apply.app;
  return (
    <Stack direction="column" sx={{ width: "100%" }} spacing={1}>
      <Stack direction="row" spacing={0.5}>
        <Box sx={headerStyle ? headerStyle : ApplicationInputStyle.subheader}>
          Selected Resume
        </Box>
        <Tooltip
          title="You can save up to three resumes on Fetti for quick applying. Uploading more than three will overwrite your oldest resume."
          placement="right">
          <HelpIcon
            sx={{
              fontSize: "10px",
              position: "relative",
              top: "3px",
              cursor: "pointer",
            }}
          />
        </Tooltip>
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}>
        <FettiSelect
          options={[
            ["", "Your Resume Uploads"],
            ...apply.serverData.resumes,
          ].map((option, index) => ({
            value: option[0],
            label: option[1],
          }))}
          firstIsPlaceholder
          value={appData.resume ? appData.resume[0] : ""}
          onChange={(v) => {
            console.log("setting", v.target.value, apply.serverData.resumes);
            updateAppData(dispatch, {
              // resume: v.target.value,
              resume: apply.serverData.resumes.find(
                (resume) => resume[0] === parseInt(v.target.value)
              ),
            });
          }}
        />
        {appData.resume ? (
          <CheckCircleIcon
            sx={{ color: Color.mainGreen, width: "36px", height: "36px" }}
          />
        ) : null}
      </Stack>
    </Stack>
  );
};

export default ResumeSelect;
